module.exports = __webpack_public_path__ + "static/img/bridge-text-2.eb93b727.png";